/**
 * Mock data para el framework de adopción de IA
 * Datos en español e inglés
 * Nueva estructura: cada topTitle puede contener múltiples items
 */

// Datos en español - nueva estructura agrupada
export const frameworkDataEs = {
  data: [
    {
      attributes: {
        area: "Framework",
        topTitle: "Bases",
        items: [
          {
            title: "Liderazgo",
            description: "Los ejecutivos deben patrocinar y alinear la IA con la estrategia de negocio, garantizando visión, autoridad y recursos.",
            url: "liderazgo-vision",
            showButton: false
          }, 
          {
            title: "Capacitación y desarrollo",
            description: "La adopción requiere reconversión de habilidades y acompañamiento cultural para reducir resistencia y generar compromiso.",
            url: "gestion-cambio",
            showButton: false
          },
          {
            title: "Infraestructura y seguridad",
            description: "Se necesita una infraestructura robusta, controles de seguridad y desarrollo de capacidades que hagan la IA escalable y sostenible.",
            url: "preparacion-tecnica",
            showButton: false
          }
        ]
      }
    },
    
    {
      attributes: {
        area: "Framework",
        topTitle: "Ejes Estratégicos",
        items: [
          {
            title: "Estrategia y gobernanza de IA",
            description: "Definir políticas de IA, estructuras de toma de decisiones y principios éticos para garantizar un uso responsable.",
            url: "estrategia-gobernanza",
            showButton: false
          },
          {
            title: "Calidad y gobernanza de datos",
            description: "Asegurar la disponibilidad, calidad y gobernanza de datos necesarios para habilitar la IA.",
            url: "estrategia-datos",
            showButton: false
          },
          {
            title: "Privacidad y cumplimiento",
            description: "Proteger la privacidad, gestionar riesgos y cumplir con regulaciones para construir confianza.",
            url: "seguridad-ia-responsable",
            showButton: false
          },
          {
            title: "Infraestructura tecnológica",
            description: "Proporcionar plataformas, arquitecturas y herramientas que soporten la adopción y evolución de la IA.",
            url: "infraestructura-tecnologica",
            showButton: false
          },
          {
            title: "Cultura organizacional y capacitación",
            description: "Fomentar una mentalidad orientada a la IA mediante aprendizaje continuo y comunidades de práctica.",
            url: "cultura-capacitacion",
            showButton: false
          }
        ]
      }
    },    
    {
      attributes: {
        area: "Framework",
        topTitle: "Etapas",
        items: [
          {
            title: "Preparar",
            description: "Definir visión, escenarios iniciales y recursos para comenzar la adopción de IA.",
            url: "preparar",
            showButton: false
          },
          {
            title: "Incorporar",
            description: "Entrenar, comunicar y activar agentes de cambio para integrar la IA en la organización.",
            url: "incorporar",
            showButton: false
          },
          {
            title: "Generar impacto",
            description: "Medir resultados e identificar áreas de mejora para maximizar el impacto de la IA.",
            url: "generar-impacto",
            showButton: false
          },
          {
            title: "Escalamiento y optimización",
            description: "Escalar a nuevas áreas y consolidar prácticas de mejora continua.",
            url: "escalamiento-optimizacion",
            showButton: false
          }
        ]
      }
    },
  ]
};

// Datos en inglés - nueva estructura agrupada
export const frameworkDataEn = {
  data: [
    {
      attributes: {
        area: "Framework",
        topTitle: "Foundations",
        items: [
          {
            title: "Leadership",
            description: "Executives must sponsor AI initiatives and align them with business strategy, ensuring vision, authority, and resources.",
            url: "leadership",
            showButton: false
          },
          {
            title: "Human Change Management",
            description: "Adoption requires skill transformation and cultural support to reduce resistance and build commitment.",
            url: "human-change-management",
            showButton: false
          },
          {
            title: "Technical Readiness",
            description: "Robust infrastructure, security controls, and capability development are essential to make AI scalable and sustainable.",
            url: "technical-readiness",
            showButton: false
          }
        ]
      }
    },
    {
      attributes: {
        area: "Framework",
        topTitle: "Strategic Pillars",
        items: [
          {
            title: "AI Strategy and Governance",
            description: "Define AI policies, decision-making structures, and ethical principles to ensure responsible use.",
            url: "ai-strategy-governance",
            showButton: false
          },
          {
            title: "Data Strategy",
            description: "Ensure the availability, quality, and data governance needed to enable AI.",
            url: "data-strategy",
            showButton: false
          },
          {
            title: "Security and Responsible AI",
            description: "Protect privacy, manage risks, and comply with regulations to build trust.",
            url: "security-responsible-ai",
            showButton: false
          },
          {
            title: "Technology Infrastructure",
            description: "Provide platforms, architectures, and tools that support AI adoption and evolution.",
            url: "technology-infrastructure",
            showButton: false
          },
          {
            title: "Organizational Culture and Training",
            description: "Promote an AI-oriented mindset through continuous learning and practice communities.",
            url: "organizational-culture-training",
            showButton: false
          }
        ]
      }
    },    
    {
      attributes: {
        area: "Framework",
        topTitle: "Stages",
        items: [
          {
            title: "Prepare",
            description: "Define vision, initial scenarios, and resources.",
            url: "prepare",
            showButton: false
          },
          {
            title: "Integrate",
            description: "Train, communicate, and activate change agents.",
            url: "integrate",
            showButton: false
          },
          {
            title: "Drive Impact",
            description: "Measure results and identify areas for improvement.",
            url: "drive-impact",
            showButton: false
          },
          {
            title: "Scale and Optimize",
            description: "Scale to new areas and consolidate continuous improvement practices.",
            url: "scale-optimize",
            showButton: false
          }
        ]
      }
    }
  ]
};
